import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/website/node_modules/next/dist/client/app-dir/link.js");
